export default __webpack_public_path__ + "static/media/Strifescar Harness.77127881.jpg";